module.exports = __webpack_public_path__ + "img/people_zpc.deda013b.png";